export const getChoiceLabel = (choices, value) => {
    if (!Array.isArray(choices) || value == null || value === '') {
        return '';
    }

    const match = choices.find((choice) => choice.value == value);
    return match?.label ?? '';
};
